import React from "react";
import Accordion from "react-bootstrap/Accordion";
import {
  faArrowDown,
  faArrowUp,
  faTriangleExclamation,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./Base.css";

const BaseAccordionItem = ({
  eventKey,
  expandedContent,
  expandedItem,
  headerText,
  isValid = true,
  onExpandItem,
}) => {
  const isExpanded = headerText === expandedItem;

  const toggleArrow = () => {
    onExpandItem(isExpanded ? "" : headerText);
  };
 
  return (
    <Accordion.Item eventKey={eventKey}>
      <Accordion.Header onClick={toggleArrow}>
        <div className="Row">
          <div className="Row">
            <h5 className="Green m-0">{headerText}</h5>
            {!isValid && (
              <FontAwesomeIcon
                icon={faTriangleExclamation}
                className="warning-icon m4"
              />
            )}
          </div>
          <FontAwesomeIcon
            className="accordion-button-override"
            icon={isExpanded ? faArrowUp : faArrowDown}
          />
        </div>
      </Accordion.Header>
      <Accordion.Body
        className={headerText === "Sort" ? "accordion-body-sort" : ""}
      >
        {expandedContent?.map((ec, index) => {
          return (
            <div
              key={`${headerText}-${index}`}
              className={headerText === "Search" ? "marg-b-1" : ""}
            >
              {ec.component}
            </div>
          );
        })}
      </Accordion.Body>
    </Accordion.Item>
  );
};

export default BaseAccordionItem;
